import { render, staticRenderFns } from "./PatientDetailModal.vue?vue&type=template&id=f731fb4c&"
import script from "./PatientDetailModal.vue?vue&type=script&lang=js&"
export * from "./PatientDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports